/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNavContent_viewer = {
    readonly isMessageCenterEnabled: boolean | null;
    readonly nftMarketplaceEnabled: boolean | null;
    readonly " $refType": "AccountNavContent_viewer";
};
export type AccountNavContent_viewer$data = AccountNavContent_viewer;
export type AccountNavContent_viewer$key = {
    readonly " $data"?: AccountNavContent_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountNavContent_viewer",
  "selections": [
    {
      "alias": "isMessageCenterEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    },
    {
      "alias": "nftMarketplaceEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftMarketplace"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftMarketplace\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '7287fe865a3bc8bbd6ad02ea9341ffa8';
export default node;
